import React from 'react'
import PrivateHeader from '../../../components/PrivateHeader/PrivateHeader'
import SocialIcons from '../../../components/SocialIcons/SocialIcons'
import { Link } from 'react-router-dom'
import HeroImg from '../../../images/hero_image.png'
import Programs from "../../../components/PrivatePrograms/PrivatePrograms"
import  Testimonials from "../../../components/Testimonial/Testimonials"
import  Newsletter from "../../../components/NewsLetter/Newsletter"
import  Footer from "../../../components/Footer/Footer"
import  Contact from "../../../components/Contact/Contact"
import  Rectangle1 from "../../../images/Rectangle1.png"
import Rectangle2 from "../../../images/Rectangle2.png"
import AboutImg from "../../../images/EllipseProfileImg.png"


function PrivateCommunity() {
  return (
    <div>
         <PrivateHeader/>

         
         <div id='myStyle'>

<div id='mainContainer'>     

<div class="container">

<div class="timeline-item">
<div className='hero1Com'>
<h1>A new way <br/> to <span>collaborate</span> </h1>
<p>Create, and learn all while working collaboratively with <br/> some of the most passionate digital enthusiasts in Africa.</p>
<Link to="/signup"> <button id="signUpBtn">LEARN MORE</button> </Link>
<SocialIcons color="#016b37" opacity="1" margin="hero-mrTop1"/>
</div>
</div>

<div class="timeline-item" >


<div id="chero-container">
<div id="cflexHero">
    <div id="cleft-container">
        <h2 id="cfirst-txt">The leading <span id="cgreen-hlt"> community <br/> of digital natives </span> <br/> in Africa</h2>
        <h2 id="csecond-txt">We are not just another community. We are <br/> a 500+ community of digital entrepreneurs, enthusiasts, beginners and veterans...</h2>
        <Link to="/signup"><button className="cjoinus-btn">JOIN US</button></Link>
    </div>
    <div id="cright-container">
        <img id="cheroImg" src={HeroImg} alt="hero"/>
    </div>

</div>

</div> 

</div>

<div class="timeline-item">

<div className='showcase'>Showcase</div>
<p>We feature some of the top digital talents <br/> in our community.</p>
{/* <Link to="/signup"><button id="signUpBtn">JOIN US</button></Link> */}

</div>

</div>


</div>


<div className='timeline-item1'>

<div className='aboutCards'>

<div id='aboutCard'>

<img src={AboutImg}  alt='' id='aboutImg'/>
<h3>Kayode Odesanya</h3>
<h4>Product Manager</h4>
<div className='aboutLocation'>
<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 3.5C7 3.04037 6.90947 2.58525 6.73358 2.16061C6.55769 1.73597 6.29988 1.35013 5.97487 1.02513C5.64987 0.700121 5.26403 0.442313 4.83939 0.266422C4.41475 0.0905301 3.95963 0 3.5 0C3.04037 0 2.58525 0.0905301 2.16061 0.266422C1.73597 0.442313 1.35013 0.700121 1.02513 1.02513C0.700121 1.35013 0.442313 1.73597 0.266422 2.16061C0.0905301 2.58525 -6.84897e-09 3.04037 0 3.5C0 4.1935 0.205 4.8385 0.5525 5.3825H0.5485C1.7285 7.23 3.5 10 3.5 10L6.4515 5.3825H6.448C6.8082 4.82068 6.99977 4.16737 7 3.5ZM3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5Z" fill="#E5E5E5"/>
</svg>
<span>Lagos, Nigeria</span>
</div>

<div className='aboutInnerCard'>
<div className='aboutImg1'>
<img src={Rectangle1} alt=''/>
</div>

<div className='aboutImg2'>
<img src={Rectangle2} alt=''/>
</div>

</div>

<Link to="/signup"><button className="view">VIEW</button></Link>

</div> 



<div id='aboutCard'>

<img src={AboutImg}  alt='' id='aboutImg'/>
<h3>Kayode Odesanya</h3>
<h4>Product Manager</h4>
<div className='aboutLocation'>
<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 3.5C7 3.04037 6.90947 2.58525 6.73358 2.16061C6.55769 1.73597 6.29988 1.35013 5.97487 1.02513C5.64987 0.700121 5.26403 0.442313 4.83939 0.266422C4.41475 0.0905301 3.95963 0 3.5 0C3.04037 0 2.58525 0.0905301 2.16061 0.266422C1.73597 0.442313 1.35013 0.700121 1.02513 1.02513C0.700121 1.35013 0.442313 1.73597 0.266422 2.16061C0.0905301 2.58525 -6.84897e-09 3.04037 0 3.5C0 4.1935 0.205 4.8385 0.5525 5.3825H0.5485C1.7285 7.23 3.5 10 3.5 10L6.4515 5.3825H6.448C6.8082 4.82068 6.99977 4.16737 7 3.5ZM3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5Z" fill="#E5E5E5"/>
</svg>
<span>Lagos, Nigeria</span>
</div>

<div className='aboutInnerCard'>
<div className='aboutImg1'>
<img src={Rectangle1} alt=''/>
</div>

<div className='aboutImg2'>
<img src={Rectangle2} alt=''/>
</div>
</div>

<Link to="/signup"><button className="view">VIEW</button></Link>


</div> 


<div id='aboutCard'>

<img src={AboutImg}  alt='' id='aboutImg'/>
<h3>Kayode Odesanya</h3>
<h4>Product Manager</h4>
<div className='aboutLocation'>
<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 3.5C7 3.04037 6.90947 2.58525 6.73358 2.16061C6.55769 1.73597 6.29988 1.35013 5.97487 1.02513C5.64987 0.700121 5.26403 0.442313 4.83939 0.266422C4.41475 0.0905301 3.95963 0 3.5 0C3.04037 0 2.58525 0.0905301 2.16061 0.266422C1.73597 0.442313 1.35013 0.700121 1.02513 1.02513C0.700121 1.35013 0.442313 1.73597 0.266422 2.16061C0.0905301 2.58525 -6.84897e-09 3.04037 0 3.5C0 4.1935 0.205 4.8385 0.5525 5.3825H0.5485C1.7285 7.23 3.5 10 3.5 10L6.4515 5.3825H6.448C6.8082 4.82068 6.99977 4.16737 7 3.5ZM3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5Z" fill="#E5E5E5"/>
</svg>
<span>Lagos, Nigeria</span>
</div>

<div className='aboutInnerCard'>
<div className='aboutImg1'>
<img src={Rectangle1} alt=''/>
</div>

<div className='aboutImg2'>
<img src={Rectangle2} alt=''/>
</div>
</div>

<Link to="/signup"><button className="view">VIEW</button></Link>


</div>


<div id='aboutCard'>

<img src={AboutImg}  alt='' id='aboutImg'/>
<h3>Kayode Odesanya</h3>
<h4>Product Manager</h4>
<div className='aboutLocation'>
<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 3.5C7 3.04037 6.90947 2.58525 6.73358 2.16061C6.55769 1.73597 6.29988 1.35013 5.97487 1.02513C5.64987 0.700121 5.26403 0.442313 4.83939 0.266422C4.41475 0.0905301 3.95963 0 3.5 0C3.04037 0 2.58525 0.0905301 2.16061 0.266422C1.73597 0.442313 1.35013 0.700121 1.02513 1.02513C0.700121 1.35013 0.442313 1.73597 0.266422 2.16061C0.0905301 2.58525 -6.84897e-09 3.04037 0 3.5C0 4.1935 0.205 4.8385 0.5525 5.3825H0.5485C1.7285 7.23 3.5 10 3.5 10L6.4515 5.3825H6.448C6.8082 4.82068 6.99977 4.16737 7 3.5ZM3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5Z" fill="#E5E5E5"/>
</svg>
<span>Lagos, Nigeria</span>
</div>

<div className='aboutInnerCard'>
<div className='aboutImg1'>
<img src={Rectangle1} alt=''/>
</div>

<div className='aboutImg2'>
<img src={Rectangle2} alt=''/>
</div>
</div>

<Link to="/signup"><button className="view">VIEW</button></Link>


</div>


<div id='aboutCard'>

<img src={AboutImg}  alt='' id='aboutImg'/>
<h3>Kayode Odesanya</h3>
<h4>Product Manager</h4>
<div className='aboutLocation'>
<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 3.5C7 3.04037 6.90947 2.58525 6.73358 2.16061C6.55769 1.73597 6.29988 1.35013 5.97487 1.02513C5.64987 0.700121 5.26403 0.442313 4.83939 0.266422C4.41475 0.0905301 3.95963 0 3.5 0C3.04037 0 2.58525 0.0905301 2.16061 0.266422C1.73597 0.442313 1.35013 0.700121 1.02513 1.02513C0.700121 1.35013 0.442313 1.73597 0.266422 2.16061C0.0905301 2.58525 -6.84897e-09 3.04037 0 3.5C0 4.1935 0.205 4.8385 0.5525 5.3825H0.5485C1.7285 7.23 3.5 10 3.5 10L6.4515 5.3825H6.448C6.8082 4.82068 6.99977 4.16737 7 3.5ZM3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5Z" fill="#E5E5E5"/>
</svg>
<span>Lagos, Nigeria</span>
</div>

<div className='aboutInnerCard'>
<div className='aboutImg1'>
<img src={Rectangle1} alt=''/>
</div>

<div className='aboutImg2'>
<img src={Rectangle2} alt=''/>
</div>
</div>

<Link to="/signup"><button className="view">VIEW</button></Link>


</div>


<div id='aboutCard'>

<img src={AboutImg}  alt='' id='aboutImg'/>
<h3>Kayode Odesanya</h3>
<h4>Product Manager</h4>
<div className='aboutLocation'>
<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 3.5C7 3.04037 6.90947 2.58525 6.73358 2.16061C6.55769 1.73597 6.29988 1.35013 5.97487 1.02513C5.64987 0.700121 5.26403 0.442313 4.83939 0.266422C4.41475 0.0905301 3.95963 0 3.5 0C3.04037 0 2.58525 0.0905301 2.16061 0.266422C1.73597 0.442313 1.35013 0.700121 1.02513 1.02513C0.700121 1.35013 0.442313 1.73597 0.266422 2.16061C0.0905301 2.58525 -6.84897e-09 3.04037 0 3.5C0 4.1935 0.205 4.8385 0.5525 5.3825H0.5485C1.7285 7.23 3.5 10 3.5 10L6.4515 5.3825H6.448C6.8082 4.82068 6.99977 4.16737 7 3.5ZM3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5Z" fill="#E5E5E5"/>
</svg>
<span>Lagos, Nigeria</span>
</div>

<div className='aboutInnerCard'>
<div className='aboutImg1'>
<img src={Rectangle1} alt=''/>
</div>

<div className='aboutImg2'>
<img src={Rectangle2} alt=''/>
</div>
</div>

<Link to="/signup"><button className="view">VIEW</button></Link>


</div>


<div id='aboutCard'>

<img src={AboutImg}  alt='' id='aboutImg'/>
<h3>Kayode Odesanya</h3>
<h4>Product Manager</h4>
<div className='aboutLocation'>
<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 3.5C7 3.04037 6.90947 2.58525 6.73358 2.16061C6.55769 1.73597 6.29988 1.35013 5.97487 1.02513C5.64987 0.700121 5.26403 0.442313 4.83939 0.266422C4.41475 0.0905301 3.95963 0 3.5 0C3.04037 0 2.58525 0.0905301 2.16061 0.266422C1.73597 0.442313 1.35013 0.700121 1.02513 1.02513C0.700121 1.35013 0.442313 1.73597 0.266422 2.16061C0.0905301 2.58525 -6.84897e-09 3.04037 0 3.5C0 4.1935 0.205 4.8385 0.5525 5.3825H0.5485C1.7285 7.23 3.5 10 3.5 10L6.4515 5.3825H6.448C6.8082 4.82068 6.99977 4.16737 7 3.5ZM3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5Z" fill="#E5E5E5"/>
</svg>
<span>Lagos, Nigeria</span>
</div>

<div className='aboutInnerCard'>
<div className='aboutImg1'>
<img src={Rectangle1} alt=''/>
</div>

<div className='aboutImg2'>
<img src={Rectangle2} alt=''/>
</div>
</div>

<Link to="/signup"><button className="view">VIEW</button></Link>


</div>


<div id='aboutCard'>

<img src={AboutImg}  alt='' id='aboutImg'/>
<h3>Kayode Odesanya</h3>
<h4>Product Manager</h4>
<div className='aboutLocation'>
<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 3.5C7 3.04037 6.90947 2.58525 6.73358 2.16061C6.55769 1.73597 6.29988 1.35013 5.97487 1.02513C5.64987 0.700121 5.26403 0.442313 4.83939 0.266422C4.41475 0.0905301 3.95963 0 3.5 0C3.04037 0 2.58525 0.0905301 2.16061 0.266422C1.73597 0.442313 1.35013 0.700121 1.02513 1.02513C0.700121 1.35013 0.442313 1.73597 0.266422 2.16061C0.0905301 2.58525 -6.84897e-09 3.04037 0 3.5C0 4.1935 0.205 4.8385 0.5525 5.3825H0.5485C1.7285 7.23 3.5 10 3.5 10L6.4515 5.3825H6.448C6.8082 4.82068 6.99977 4.16737 7 3.5ZM3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5Z" fill="#E5E5E5"/>
</svg>
<span>Lagos, Nigeria</span>
</div>

<div className='aboutInnerCard'>
<div className='aboutImg1'>
<img src={Rectangle1} alt=''/>
</div>

<div className='aboutImg2'>
<img src={Rectangle2} alt=''/>
</div>
</div>

<Link to="/signup"><button className="view">VIEW</button></Link>


</div>


<div id='aboutCard'>

<img src={AboutImg}  alt='' id='aboutImg'/>
<h3>Kayode Odesanya</h3>
<h4>Product Manager</h4>
<div className='aboutLocation'>
<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 3.5C7 3.04037 6.90947 2.58525 6.73358 2.16061C6.55769 1.73597 6.29988 1.35013 5.97487 1.02513C5.64987 0.700121 5.26403 0.442313 4.83939 0.266422C4.41475 0.0905301 3.95963 0 3.5 0C3.04037 0 2.58525 0.0905301 2.16061 0.266422C1.73597 0.442313 1.35013 0.700121 1.02513 1.02513C0.700121 1.35013 0.442313 1.73597 0.266422 2.16061C0.0905301 2.58525 -6.84897e-09 3.04037 0 3.5C0 4.1935 0.205 4.8385 0.5525 5.3825H0.5485C1.7285 7.23 3.5 10 3.5 10L6.4515 5.3825H6.448C6.8082 4.82068 6.99977 4.16737 7 3.5ZM3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5Z" fill="#E5E5E5"/>
</svg>
<span>Lagos, Nigeria</span>
</div>

<div className='aboutInnerCard'>
<div className='aboutImg1'>
<img src={Rectangle1} alt=''/>
</div>

<div className='aboutImg2'>
<img src={Rectangle2} alt=''/>
</div>
</div>

<Link to="/signup"><button className="view">VIEW</button></Link>
</div> 



</div>


</div>

</div>

<div className='newDiv2'>
<Programs/>
<Testimonials/>
<Contact/>
<Newsletter/>
<Footer/>
</div>

    </div>
  )
}

export default PrivateCommunity